/* eslint no-unused-vars: 'off', no-unreachable: 'off' */
import $ from "jquery";
import common from "@/scripts/common";
import store from "../../store";

export default {
    //inputValues: This is for reference only, as settings are passed in from caller
    //state:
    // s: {

    //     //values
    //     ctWidth: null,
    //     outerBox: null,
    //     windowWidth: null,

    //     // control1: null,
    //     // control2: null,
    //      crosstabTitle: null,
    //     ctKey: null,
    //     singleCrosstab: null,
    //     crosstabTable: null
    // },
    resize,
    resizeTable
}

function getStore(s) {
    if (!s.ctKey)
        return store.state.loadedControls;
    return store.state.loadedControls[s.ctKey];
}

function getCtRefs(ctKey) {
    let s = {};
    s.ctKey = ctKey;
    //common.getCtKeyFromControls(control1, control2);
    const theStore = getStore(s);
    if (!theStore)
        console.log(`Cant find store: key= ${s.ctKey}`);
    s.crosstabTitle = theStore.crosstabTitle;
    s.singleCrosstab = theStore.singleCrosstab;
    s.crosstabTable = theStore.crosstabTable;
    s.chiSquare = theStore.chiSquare;
    s.datasetTotals = theStore.datasetTotals;
    s.footnotes = theStore.footnotes;

    //size values. Set page wide to let tables fill the space
    s[' selectedOption'] = '0 Not set';
    s.usableWindowAreaWidth = 99999;
    s.marginLeft = 0;
    s.margin = 20;
    s.windowWidth = null;
    s.otherControlsWidth = null;
    s.containerWidthWithOverflowToRight = null;
    s.leftMarginToCenter = null;

    return s;
}

function resize() {
    for (let i = 0; i < store.state.loadedControls.levelCounts[0]; ++i)
        for (let j = 0; j < store.state.loadedControls.levelCounts[1]; ++j) {
            resizeTable(common.getCtKey(i, j));
        }
}

function resizeTable(ctKey) {
    let s = getCtRefs(ctKey);

    //Put box around report if wide (#2 or 3?)
    if (!s.singleCrosstab.usableDisplayArea)
        console.log('Cross tabulation is not loaded');
    s.usableDisplayAreaBox = s.singleCrosstab.usableDisplayArea.getBoundingClientRect();
    s.singleCrosstab.outerCrosstabWrapper.setAttribute("style", "width: 99999px; margin-left: 0px;");
    s.ctWidth = s.crosstabTable.width;
    s.crosstabTable.setColumnWidths();
    s.outerBox = s.singleCrosstab.outerCrosstabWrapper.getBoundingClientRect();
    s.wrapperBox = s.singleCrosstab.crosstabWrapper.getBoundingClientRect();



    s.windowWidth = $(window).width();
    s.containerWidthWithOverflowToRight = s.windowWidth - s.wrapperBox.left;
    s.usableWindowAreaWidth = s.windowWidth - s.margin * 2;
    s.leftMarginToCenter = getLeftMarginToCenter(s);

    //Get min of usable width and crosstab width
    s.otherControlsWidth = s.ctWidth < s.usableDisplayAreaBox.width ? s.ctWidth : s.usableDisplayAreaBox.width;

    // if (s.ctWidth > s.usableWindowAreaWidth) {
    //     s[' selectedOption'] = '1 Table is bigger than the window. This isnt practical anymore with left nav';
    //     //Table is bigger than the window
    //     // console.log('1 Table is bigger than the window');
    //     //To Do: Right justify isn't working after adding scroll
    //     //s.crosstabWrapperOld.setAttribute("style", "overflow-x: auto; ");
    //     s.marginLeft = s.singleCrosstab.vm.getLeftMarginToRightJustify(
    //         s.margin
    //     );
    //     setParentContainerStyle(s);
    //     s.otherControlsWidth = s.wrapperBox.width;
    //     centerOtherControls(s, s.wrapperBox.width);
    //     if (s.crosstabTitle.isLoaded)
    //         s.crosstabTitle.subTable.setAttribute(
    //             "style",
    //             "width:" + s.wrapperBox.width + "px"
    //         );
    // } else 

    if (s.ctWidth > s.containerWidthWithOverflowToRight) {
        s[' selectedOption'] = '2 Crosstab is bigger than parent containers left margin to the right window edge. Will need to scroll.';
        s.marginLeft = s.leftMarginToCenter;
        //s.otherControlsWidth = s.containerWidthWithOverflowToRight;
    } else if (s.ctWidth > s.wrapperBox.width) {
        s[' selectedOption'] = '3 Crosstab is bigger than outer box';
        s.marginLeft = s.leftMarginToCenter;
        //s.otherControlsWidth = s.wrapperBox.width;
    } else {
        s[' selectedOption'] = '4 Table fits in the width available';
        s.marginLeft = 0;
        //s.otherControlsWidth = s.ctWidth;
    }

    //Don't resize the title for now
    // if (s.crosstabTitle.isLoaded)
    //     s.crosstabTitle.subTable.setAttribute('style', `width: ${s.ctWidth}px`);

    //s.singleCrosstab.outerCrosstabWrapper.setAttribute("style", getParentContainerStyle(s));
    s.singleCrosstab.outerCrosstabWrapper.setAttribute("style", '');
    centerOtherControls(s, s.wrapperBox.width)
}

function getParentContainerStyle(s) {
    return `width: ${s.usableWindowAreaWidth}px; margin-left: ${s.marginLeft} px; `;
}

function centerOtherControls(s) {
    centerSubTable(s, s.chiSquare, 'chiSquare');
    centerSubTable(s, s.datasetTotals, 'datasetTotals');
    centerSubTable(s, s.footnotes, 'footnotes');
}

function centerSubTable(s, control, controlName) {
    if (!control || !control.isLoaded || !control.subTable)
        return;
    var marginLeft = Math.floor((s.otherControlsWidth - control.subTable.clientWidth) / 2);
    if (marginLeft + control.subTable.clientWidth > s.wrapperBox.width)
        marginLeft = s.wrapperBox.width - control.subTable.clientWidth;
    if (marginLeft < 0 || s.otherControlsWidth > s.wrapperBox.width) marginLeft = 0;
    const newStyle = `margin-left: ${marginLeft}px; `;
    control.subTable.setAttribute('style', newStyle);
}

function getLeftMarginToCenter(s) {
    const newControlLeft = (s.windowWidth - s.ctWidth) / 2 - s.margin;
    const newLeftMargin = -1 * (s.outerBox.left - newControlLeft);
    return newLeftMargin;
}
